import {InputLabel, MenuItem, Select} from "@material-ui/core";
import React from "react";
import {FormattedMessage} from "react-intl";
import {getLanguageNow, setLanguage} from "../../../i18n";

const SelectLanguage = ({languages}) => {
  const [lang, setLang] = React.useState(getLanguageNow());

  const handleChange = (event) => {
    setLang(event.target.value);
    setLanguage(event.target.value);
  };

  return (
    <div style={{backgroundColor: '#6c7a89b3', padding: 10}}>
      <InputLabel style={{
        fontSize: '1.5rem',
        color: '#fff'
      }}>
        <FormattedMessage id="GT.LANG.SELECT" />:
      </InputLabel>

      <Select
        value={lang}
        onChange={handleChange}
        style={{
          backgroundColor: '#ffffffbf',
          width: '100%',
          margin: '0 auto',
          display: 'block',
          fontSize: '1.3rem'
        }}
      >
        {languages.map(one => (
          <MenuItem value={one}><FormattedMessage id={`GT.LANG.${one.toString().toUpperCase()}`} /></MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default SelectLanguage;
